<template>
    <div class="holdRuleGroupEdit">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <b-card-title class="mb-3">
                        Bewerken van groep
                    </b-card-title>
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col cols="12" lg="3">
                    Omschrijving:<br/>
                    <b-input v-model="localState.groupData.display_name" autocomplete="off" size="sm"/>
                </b-col>
            </b-row>

            <b-row class="mb-1">
                <b-col cols="12">
                    <b-form-checkbox
                        v-model="localState.groupData.is_active"
                        name="is_active"
                        :value="1"
                        :unchecked-value="0"
                        switch
                    >
                        <span class="small">Deze blokkering is actief</span>
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <b-row class="mb-1">
                <b-col cols="12">
                    <b-form-checkbox
                        v-model="localState.isNotApprovable"
                        name="is_approvable"
                        :value="true"
                        :unchecked-value="false"
                        switch
                    >
                        <span class="small">
                            Deze blokkering kan alleen worden opgeheven door de orderdata te wijzigen
                            <font-awesome-icon icon="circle-info" class="text-info ml-2"
                                               :title="`Sommige hold rules controleren of alle data wel correct gevuld is. `
                                                            +`Orders met ontbrekende of verkeerd geformatteerde data kunnen verderop in het proces voor problemen zorgen. `
                                                            +`Zet deze optie bij dit soort hold rules aan dat om te voorkomen.`
                                               "
                            />
                        </span>
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <b-row class="mb-5">
                <b-col cols="12">
                    <b-form-checkbox
                        v-model="localState.groupData.is_status_hold_final"
                        name="is_active"
                        :value="1"
                        :unchecked-value="0"
                        switch
                    >
                        <span class="small">Deze blokkering is direct definitief</span>
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <b-row class="mb-5">
                <b-col cols="12">
                    <GroupRulesEdit
                        :rules="localState.groupData.hold_rules"
                        @removeRule="onRuleRemoval"
                        @createRule="onRuleCreation"
                    />
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col cols="12">
                    <b-button-group>
                        <b-button @click="cancelEdit" variant="secondary">
                            <i class="fas fa-times"/>
                            Annuleren
                        </b-button>

                        <b-button
                            @click="confirmEdit"
                            variant="success"
                            :disabled="!dataHasChanged"
                        >
                            <i class="fas fa-save"/>
                            Opslaan
                        </b-button>
                    </b-button-group>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<style lang="scss">
.holdRuleGroupEdit {
    margin-bottom: 1.5rem;
}
</style>

<script>
import _ from "lodash";
import GroupRulesEdit from "./components/GroupRulesEdit.vue";

export default {
    name: "HoldRuleGroupEdit",

    props: {
        groupIdentifier: {
            type: String,
            required: true,
        },
        groupData: {
            type: Object,
            required: true,
        },
    },

    components: {
        GroupRulesEdit,
    },

    data() {
        return {
            localState: {
                groupData: [], // declared here, but initialised on mount hook, for reasons ;)
                isNotApprovable: null,
            },
        };
    },

    mounted() {
        this.localState.groupData = _.cloneDeep(this.groupData);
        this.localState.isNotApprovable = !this.localState.groupData.is_approvable;
    },

    methods: {
        updateReplaceGroupData() {
            const apiPath = `/api/rest/hold-rule-groups/${this.groupIdentifier}`;

            this.$http
                .put(apiPath, this.localState.groupData)
                .then((response) => {
                    this.$alert("De groep is aangepast", "success", true);
                    this.$emit("refresh"); // ask the parent to refresh the data;
                    this.$router.push({
                        name: "holdRuleGroupView",
                        params: this.$route.params,
                    });
                })
                .catch((e) => {
                    this.$alert(
                        "Er is iets misgegaan bij het aanpassen van de groep",
                        "danger",
                        true
                    );
                    console.log(e);
                })
                .then(() => {
                });
        },

        cancelEdit() {
            this.$router.push({
                name: "holdRuleGroupView",
                params: this.$route.params,
            });
        },

        confirmEdit() {
            this.updateReplaceGroupData();
        },

        onRuleCreation() {
            this.localState.groupData.hold_rules.push({
                id: -Math.floor(Math.random() * 1000000 - 1),
                relation: "address",
                field: "email",
                operator: "=",
                value: "jan.smit@voorbeeld.nl",
            });
        },

        onRuleRemoval(rule) {
            this.localState.groupData.hold_rules =
                this.localState.groupData.hold_rules.filter((r) => r.id !== rule.id);
        },
    },

    computed: {
        /**
         * Returns the page title
         * @returns {string} Page title
         */
        pageTitle() {
            const groupName = !this.groupDataLoading
                ? this.localState.groupData["display_name"]
                : "...";
            return `Hold Order Group: ${groupName}`;
        },

        /**
         * Compares the groupData prop with the localState groupData. It returns `true` when they are different,
         * `false` when they are the same. This is used to determine if there are changes to be saved, e.g.
         * adding, removing or editing individual rules within the group.
         *
         * It also allows the user to be prompted to confirm the changes before leaving the page,
         * or if the changes can be discarded, et cetera.
         */
        dataHasChanged() {
            return !_.isEqual(this.groupData, this.localState.groupData);
        },
    },

    watch: {
        'localState.isNotApprovable'(val) {
            this.localState.groupData.is_approvable = !val
        },
    },
};
</script>
